const my_settings = {};

my_settings.api_domain="http://127.0.0.1:8000";
my_settings.ec2_domain="http://ec2-54-89-140-232.compute-1.amazonaws.com:8000";

export default my_settings;
